// extracted by mini-css-extract-plugin
export default {"dataBox":"DataBox_dataBox__iPJlo","bottomWrapper":"DataBox_bottomWrapper__CDpOS","counter":"DataBox_counter__S9BYe"};